import { createSlice } from '@reduxjs/toolkit';

import { InjectedSite, Reducer } from '../../types';
import SiteBuilder from '../../services/site-builder';
import { checkIfSiteIsSocial } from '../../services/social-status';

export type SetInstalledAppsPayload = Pick<InjectedSite, 'installedApps'>;

export type SetIsSocialChatPayload = Pick<InjectedSite, 'isSocialChat'>;

export type SetSettingsTabPayload = Pick<InjectedSite, 'settingsTab'>;

export type SetIsWidgetPluginPayload = Pick<InjectedSite, 'isWidgetPlugin'>;

export type SetCurrentTabIdPayload = Pick<InjectedSite, 'currentTabId'>;

const name = 'site';

const initialState = new SiteBuilder().build();

const setInstalledApps: Reducer<InjectedSite, SetInstalledAppsPayload> = (
  state,
  { payload },
) => ({
  ...state,
  installedApps: payload.installedApps,
  isSocial: checkIfSiteIsSocial(payload.installedApps),
});

const setIsSocialChat: Reducer<InjectedSite, SetIsSocialChatPayload> = (
  state,
  { payload },
) => ({ ...state, isSocialChat: payload.isSocialChat });

const setSettingsTab: Reducer<InjectedSite, SetSettingsTabPayload> = (
  state,
  { payload },
) => ({
  ...state,
  settingsTab: payload.settingsTab,
});

const setIsWidgetPlugin: Reducer<InjectedSite, SetIsWidgetPluginPayload> = (
  state,
  { payload },
) => ({ ...state, isWidgetPlugin: payload.isWidgetPlugin });

const setCurrentTabId: Reducer<InjectedSite, SetCurrentTabIdPayload> = (
  state,
  { payload },
) => ({
  ...state,
  currentTabId: payload.currentTabId,
});

const reducers = {
  setInstalledApps,
  setIsSocialChat,
  setSettingsTab,
  setIsWidgetPlugin,
  setCurrentTabId,
};

const siteSlice = createSlice({ name, initialState, reducers });

export default siteSlice;
